"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var global_1 = require("./global");
var types_1 = require("./types");
exports.instOf = function (value, cls) {
    if (types_1.isFn(cls))
        return value instanceof cls;
    if (types_1.isStr(cls))
        return global_1.globalThisPolyfill[cls]
            ? value instanceof global_1.globalThisPolyfill[cls]
            : false;
    return false;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/shared/lib/instanceof.js
// module id = 531
// module chunks = 0